export enum ItemRarity {
    None = 'none',
    Common = 'common',
    Gold = 'gold',
    Diamond = 'diamond',
    Rare = 'rare',
    Heroic = 'heroic',
    Mythic = 'mythic',
    Set = 'set',
    Food = 'food',
}

export enum Region {
    Woodland = 'woodland',
    Swampland = 'swampland',
    Event = 'event',
}

export enum ItemPool {
    Unobtainable = 'unobtainable',
    Woodland_1 = 'woodland_1',
    Woodland_2 = 'woodland_2',
    Woodland_3 = 'woodland_3',
    Swampland_1 = 'swampland_1',
    Swampland_2 = 'swampland_2',
    Swampland_3 = 'swampland_3',
    Halloween = 'halloween',
    Easter = 'easter',
}

export const regionPools: Record<Region, ItemPool[]> = {
    [Region.Woodland]: [
        ItemPool.Woodland_1,
        ItemPool.Woodland_2,
        ItemPool.Woodland_3,
    ],
    [Region.Swampland]: [
        ItemPool.Swampland_1,
        ItemPool.Swampland_2,
        ItemPool.Swampland_3,
    ],
    [Region.Event]: [
        ItemPool.Halloween,
        // ItemPool.Easter,
    ],
};

export enum ItemTag {
    Wood = 'Wood',
    Stone = 'Stone',
    Bomb = 'Bomb',
    Sanguine = 'Sanguine',
    Water = 'Water',
    Food = 'Food',
    // Unique = 'Unique',
    Potion = 'Potion',
    Instrument = 'Instrument',
    Jewelry = 'Jewelry',
}

export enum ItemName {
    Empty = 'empty',
    Unknown = 'unknown',
    Any_Ring = 'any_ring',
    Jagged_Edge = 'jagged_edge', // this is an enchant, not an item ...
    // Basic Foods
    Cherry_Bomb = 'cherry_bomb',
    Clearspring_Watermelon = 'clearspring_watermelon',
    Honeycomb = 'honeycomb',
    Poisonous_Mushroom = 'poisonous_mushroom',
    Redwood_Roast = 'redwood_roast',
    Silverscale_Fish = 'silverscale_fish',
    Sour_Lemon = 'sour_lemon',
    Spiny_Chestnut = 'spiny_chestnut',
    Stone_Steak = 'stone_steak',
    Vampiric_Wine = 'vampiric_wine',
    Grilling_Skewer = 'grilling_skewer',
    Seasonal_Pumpkin = 'seasonal_pumpkin',
    // Hardboiled_Egg = 'hardboiled_egg',
    // Food Weapons
    Blackbriar_Bow = 'blackbriar_bow',
    Broken_Winebottle = 'broken_winebottle',
    // Cherry_Blade = 'cherry_blade',
    Cherrytree_Branch = 'cherrytree_branch',
    Deathcap_Bow = 'deathcap_bow',
    Ham_Bat = 'ham_bat',
    Lemontree_Branch = 'lemontree_branch',
    Melonvine_Whip = 'melonvine_whip',
    Rocksalt_Sword = 'rocksalt_sword',
    Silverscale_Swordfish = 'silverscale_swordfish',
    Pumpkin_Lance = 'pumpkin_lance',
    Bee_Stinger = 'bee_stinger',
    // Frying_Pan = 'frying_pan',
    // Honey Food
    Candied_Nuts = 'candied_nuts',
    Honey_Caviar = 'honey_caviar',
    Honey_Glazed_Shroom = 'honey_glazed_shroom',
    Honey_Ham = 'honey_ham',
    Honeydew_Melon = 'honeydew_melon',
    Lemon_Syrup = 'lemon_syrup',
    Rock_Candy = 'rock_candy',
    Sugar_Bomb = 'sugar_bomb',
    Honey_Mead = 'honey_mead',
    // Creme_Brulee = 'creme_brulee',
    // Remaining Cooked Food
    Pickled_Pumpkin = 'pickled_pumpkin',
    Pumpkin_Pie = 'pumpkin_pie',
    Poisonous_Pumpkin = 'poisonous_pumpkin',
    Buoyant_Pumpkin = 'buoyant_pumpkin',
    Swan_Gourd = 'swan_gourd',
    Prickly_Pumpkin = 'prickly_pumpkin',
    Explosive_Pumpkin = 'explosive_pumpkin',
    Roasted_Pumpkin = 'roasted_pumpkin',
    Petrified_Pumpkin = 'petrified_pumpkin',
    Bloodwine_Gourd = 'bloodwine_gourd',
    Bitter_Melon = 'bitter_melon',
    Blood_Orange = 'blood_orange',
    Blood_Sausage = 'blood_sausage',
    Bloody_Steak = 'bloody_steak',
    Boiled_Ham = 'boiled_ham',
    Cherry_Cocktail = 'cherry_cocktail',
    Combustible_Lemon = 'combustible_lemon',
    // Deepsea_Wine = 'deepsea_wine',
    Crimson_Fish = 'crimson_fish',
    Explosive_Fish = 'explosive_fish',
    Explosive_Roast = 'explosive_roast',
    // Granite_Cherry = 'granite_cherry',
    Cherry_Steak = 'cherry_steak',
    Melon_Seeds = 'melon_seeds',
    Lemon_Roast = 'lemon_roast',
    Lemon_Shark = 'lemon_shark',
    Limestone_Fruit = 'limestone_fruit',
    Marble_Mushroom = 'marble_mushroom',
    Marbled_Stonefish = 'marbled_stonefish',
    Melon_Bomb = 'melon_bomb',
    Melon_Lemonade = 'melon_lemonade',
    Melon_Sangria = 'melon_sangria',
    Mineral_Water = 'mineral_water',
    Moldy_Meat = 'moldy_meat',
    Mushroom_Soup = 'mushroom_soup',
    Petrified_Chestnut = 'petrified_chestnut',
    Poisonous_Durian = 'poisonous_durian',
    Poisonous_Lemon = 'poisonous_lemon',
    Poisonous_Pufferfish = 'poisonous_pufferfish',
    Roasted_Chestnut = 'roasted_chestnut',
    Rock_Roast = 'rock_roast',
    Shark_Roast = 'shark_roast',
    Spiked_Wine = 'spiked_wine',
    Spiny_Kiwifruit = 'spiny_kiwifruit',
    Spiny_Snapper = 'spiny_snapper',
    // Toxic_Cherry = 'toxic_cherry',
    Twin_Mushroom = 'twin_mushroom',
    Trail_Mix = 'trail_mix',
    Underwater_Watermelon = 'underwater_watermelon',
    // Baked_Egg = 'baked_egg',
    // Eggnog = 'eggnog',
    // Explosive_Egg = 'explosive_egg',
    // Fish_Egg = 'fish_egg',
    // Pickled_Egg = 'pickled_egg',
    // Melon_Egg = 'melon_egg',
    // Rotten_Egg = 'rotten_egg',
    // Spiky_Egg = 'spiky_egg',
    // Stone_Egg = 'stone_egg',
    // Potions
    Lightspeed_Potion = 'lightspeed_potion',
    Muscle_Potion = 'muscle_potion',
    Petrifying_Flask = 'petrifying_flask',
    Heart_Shaped_Potion = 'heart_shaped_potion',
    Lightning_Bottle = 'lightning_bottle',
    Nerve_Poison = 'nerve_poison',
    Purelake_Potion = 'purelake_potion',
    Slime_Potion = 'slime_potion',
    Viper_Extract = 'viper_extract',
    Ironskin_Potion = 'ironskin_potion',
    // Elixirs
    Lightspeed_Elixir = 'lightspeed_elixir',
    Muscle_Elixir = 'muscle_elixir',
    Petrifying_Elixir = 'petrifying_elixir',
    Heart_Shaped_Elixir = 'heart_shaped_elixir',
    Lightning_Elixir = 'lightning_elixir',
    Nerve_Elixir = 'nerve_elixir',
    Purelake_Elixir = 'purelake_elixir',
    Slime_Elixir = 'slime_elixir',
    Viper_Elixir = 'viper_elixir',
    Ironskin_Elixir = 'ironskin_elixir',
    // Eggs
    Wet_Egg = 'wet_egg',
    Treebark_Egg = 'treebark_egg',
    Granite_Egg = 'granite_egg',
    Deviled_Egg = 'deviled_egg',
    Easter_Egg = 'easter_egg',
    // Hatchlings
    Clearspring_Duck = 'clearspring_duck',
    Liferoot_Beast = 'liferoot_beast',
    Sanguine_Imp = 'sanguine_imp',
    Stoneborn_Turtle = 'stoneborn_turtle',
    Easter_Bunny = 'easter_bunny',
    // Remaining Items
    Basilisk_Fang = 'basilisk_fang',
    Basilisk_Scale = 'basilisk_scale',
    Bloodmoon_Dagger = 'bloodmoon_dagger',
    Swiftstrike_Gauntlet = 'swiftstrike_gauntlet',
    Assault_Greaves = 'assault_greaves',
    Brittlebark_Bow = 'brittlebark_bow',
    Brittlebark_Buckler = 'brittlebark_buckler',
    Brittlebark_Armor = 'brittlebark_armor',
    Champions_Armor = 'champions_armor',
    Champions_Blade = 'champions_blade',
    Elderwood_Staff = 'elderwood_staff',
    Elderwood_Necklace = 'elderwood_necklace',
    Chainmail_Armor = 'chainmail_armor',
    Chainmail_Sword = 'chainmail_sword',
    Pinecone_Breastplate = 'pinecone_breastplate',
    Ironstone_Spear = 'ironstone_spear',
    Ironstone_Sandals = 'ironstone_sandals',
    Forge_Hammer = 'forge_hammer',
    Forge_Gauntlet = 'forge_gauntlet',
    Crimson_Fang = 'crimson_fang',
    Venomous_Fang = 'venomous_fang',
    // Ironstone_Bracelet = 'ironstone_bracelet',
    Petrified_Statue = 'petrified_statue',
    Iron_Transfusion = 'iron_transfusion',
    Lifeblood_Armor = 'lifeblood_armor',
    Marble_Sword = 'marble_sword',
    Serpent_Lyre = 'serpent_lyre',
    Marshlight_Lantern = 'marshlight_lantern',
    Riverflow_Violin = 'riverflow_violin',
    Leather_Boots = 'leather_boots',
    Leather_Glove = 'leather_glove',
    Leather_Vest = 'leather_vest',
    Redwood_Rod = 'redwood_rod',
    Redwood_Cloak = 'redwood_cloak',
    Redwood_Helmet = 'redwood_helmet',
    Featherweight_Blade = 'featherweight_blade',
    Saffron_Feather = 'saffron_feather',
    Sanguine_Scepter = 'sanguine_scepter',
    Granite_Gemstone = 'granite_gemstone',
    Spearshield_Lance = 'spearshield_lance',
    Bramble_Buckler = 'bramble_buckler',
    Moonlight_Crest = 'moonlight_crest',
    Sunlight_Crest = 'sunlight_crest',
    Sanguine_Morphosis = 'sanguine_morphosis',
    Vampiric_Stasis = 'vampiric_stasis',
    Weaver_Armor = 'weaver_armor',
    Weaver_Shield = 'weaver_shield',
    // Tome_Of_The_Hero = 'tome_of_the_hero',
    Silver_Arrow = 'silver_arrow',
    Rusty_Sword = 'rusty_sword',
    Rusted_Plate = 'rusted_plate',
    Sword_Of_The_Hero = 'sword_of_the_hero',
    Boots_Of_The_Hero = 'boots_of_the_hero',
    Shield_Of_The_Hero = 'shield_of_the_hero',
    Holy_Shield = 'holy_shield',
    Holy_Tome = 'holy_tome',
    Bloodstone_Ring = 'bloodstone_ring',
    Bloodlords_Axe = 'bloodlords_axe',
    Boom_Stick = 'boom_stick',
    Razorthorn_Spear = 'razorthorn_spear',
    Brittlebark_Club = 'brittlebark_club',
    Evergrowth_Spear = 'evergrowth_spear',
    Fungal_Rapier = 'fungal_rapier',
    Mushroom_Buckler = 'mushroom_buckler',
    Leather_Whip = 'leather_whip',
    Silverscale_Trident = 'silverscale_trident',
    Pacifist_Staff = 'pacifist_staff',
    // Citrine_Gemstone = 'citrine_gemstone',
    Ironstone_Greatsword = 'ironstone_greatsword',
    Gale_Staff = 'gale_staff',
    Swiftstrike_Rapier = 'swiftstrike_rapier',
    Liferoot_Staff = 'liferoot_staff',
    Melting_Iceblade = 'melting_iceblade',
    Frozen_Iceblade = 'frozen_iceblade',
    Stoneslab_Sword = 'stoneslab_sword',
    Serpent_Dagger = 'serpent_dagger',
    Small_Kazoo = 'small_kazoo',
    Liferoot_Banjo = 'liferoot_banjo',
    Ore_Heart = 'ore_heart',
    Oak_Heart = 'oak_heart',
    Glacial_Spoon = 'glacial_spoon',
    Silver_Fork = 'silver_fork',
    Woodcutters_Axe = 'woodcutters_axe',
    Woodcutters_Boots = 'woodcutters_boots',
}

export enum ItemSetName {
    Boom_Spear = 'boom_spear',
    Brittlebark_Blade = 'brittlebark_blade',
    Spear_of_the_Hero = 'spear_of_the_hero',
    Bloodlords_Whip = 'bloodlords_whip',
    Pacifist_Trident = 'pacifist_trident',
    GaleStrike_Rapier = 'galestrike_rapier',
    Liferoot_Dagger = 'liferoot_dagger',
    Perfect_Iceblade = 'perfect_iceblade',
    Stonesnake_Sword = 'stonesnake_sword',
    Agaric_Armor = 'agaric_armor',
    Basilisks_Gaze = 'basilisks_gaze',
    Bloodmoon_Strike = 'bloodmoon_strike',
    Bloodstone_Pendant = 'bloodstone_pendant',
    Briar_Greaves = 'briar_greaves',
    Brittlebark_Blessing = 'brittlebark_blessing',
    Champions_Greaves = 'champions_greaves',
    // Crystal_Mirror = 'crystal_mirror',
    Deadly_Toxin = 'deadly_toxin',
    Elderwood_Mask = 'elderwood_mask',
    Frozen_Spork = 'frozen_spork',
    Golden_Jigsaw = 'golden_jigsaw',
    Heros_Return = 'heros_return',
    Highborn = 'highborn',
    Holy_Crucifix = 'holy_crucifix',
    Iron_Chain = 'iron_chain',
    Ironbark_Crest = 'ironbark_crest',
    Ironbark_Shield = 'ironbark_shield',
    Ironstone_Arrowhead = 'ironstone_arrowhead',
    Ironstone_Crest = 'ironstone_crest',
    Ironstone_Fang = 'ironstone_fang',
    // Ironstone_Gem = 'ironstone_gem',
    // Ironstone_Ore = 'ironstone_ore',
    Lifeblood_Transfusion = 'lifeblood_transfusion',
    Marble_Anvil = 'marble_anvil',
    Marshlight_Aria = 'marshlight_aria',
    Raw_Hide = 'raw_hide',
    Redwood_Crown = 'redwood_crown',
    Saffron_Talon = 'saffron_talon',
    // Sanguine_Gemstone = 'sanguine_gemstone',
    Seafood_Hotpot = 'seafood_hotpot',
    Steelplated_Thorns = 'steelplated_thorns',
    Twilight_Crest = 'twilight_crest',
    // Vampire_Cloak = 'vampire_cloak',
    Weaver_Medallion = 'weaver_medallion',
    Woodcutters_Regret = 'woodcutters_regret',
    Liquid_Metal = 'liquid_metal',
    // Glasses_Of_The_Hero = 'glasses_of_the_hero',
}


export const WOODLAND_SETS: ItemSetName[] = [
    ItemSetName.Bloodmoon_Strike,
    ItemSetName.Briar_Greaves,
    ItemSetName.Brittlebark_Blessing,
    ItemSetName.Elderwood_Mask,
    ItemSetName.Heros_Return,
    ItemSetName.Highborn,
    ItemSetName.Ironbark_Crest,
    ItemSetName.Ironbark_Shield,
    // ItemSetName.Ironstone_Gem,
    ItemSetName.Lifeblood_Transfusion,
    ItemSetName.Raw_Hide,
    ItemSetName.Redwood_Crown,
    ItemSetName.Saffron_Talon,
    ItemSetName.Steelplated_Thorns,
    ItemSetName.Boom_Spear,
    ItemSetName.Brittlebark_Blade,
    ItemSetName.Frozen_Spork,
    ItemSetName.Spear_of_the_Hero,
];
export const SWAMPLAND_SETS: ItemSetName[] = [
    ItemSetName.Agaric_Armor,
    ItemSetName.Basilisks_Gaze,
    ItemSetName.Bloodstone_Pendant,
    ItemSetName.Champions_Greaves,
    ItemSetName.Deadly_Toxin,
    ItemSetName.Golden_Jigsaw,
    // ItemSetName.Glasses_Of_The_Hero,
    ItemSetName.Holy_Crucifix,
    ItemSetName.Ironstone_Crest,
    ItemSetName.Ironstone_Fang,
    ItemSetName.Liquid_Metal,
    ItemSetName.Marble_Anvil,
    ItemSetName.Marshlight_Aria,
    ItemSetName.Seafood_Hotpot,
    ItemSetName.Twilight_Crest,
    // ItemSetName.Vampire_Cloak,
    ItemSetName.Weaver_Medallion,
    ItemSetName.Bloodlords_Whip,
    ItemSetName.Pacifist_Trident,
];
export const KINGMAKER_SETS: ItemSetName[] = [
    // ItemSetName.Ironstone_Ore,
    ItemSetName.Iron_Chain,
    ItemSetName.Ironstone_Arrowhead,
    // ItemSetName.Sanguine_Gemstone,
    ItemSetName.Woodcutters_Regret,
    ItemSetName.GaleStrike_Rapier,
    ItemSetName.Liferoot_Dagger,
    ItemSetName.Perfect_Iceblade,
    ItemSetName.Stonesnake_Sword,
];
export const BASIC_FOODS: ItemName[] = [
    ItemName.Redwood_Roast,
    ItemName.Spiny_Chestnut,
    ItemName.Cherry_Bomb,
    ItemName.Stone_Steak,
    ItemName.Vampiric_Wine,
    ItemName.Silverscale_Fish,
    ItemName.Clearspring_Watermelon,
    ItemName.Sour_Lemon,
    ItemName.Poisonous_Mushroom,
    ItemName.Grilling_Skewer,
    ItemName.Seasonal_Pumpkin,
    // ItemName.Hardboiled_Egg,
    ItemName.Honeycomb,
];

export const ELIXIRS: ItemName[] = [
    ItemName.Lightspeed_Elixir,
    ItemName.Muscle_Elixir,
    ItemName.Petrifying_Elixir,
    ItemName.Heart_Shaped_Elixir,
    ItemName.Lightning_Elixir,
    ItemName.Nerve_Elixir,
    ItemName.Purelake_Elixir,
    ItemName.Slime_Elixir,
    ItemName.Viper_Elixir,
    ItemName.Ironskin_Elixir,
]

export const HATCHLINGS: ItemName[] = [
    ItemName.Clearspring_Duck,
    ItemName.Liferoot_Beast,
    ItemName.Sanguine_Imp,
    ItemName.Stoneborn_Turtle,
    ItemName.Easter_Bunny,
]

export type ItemStats = {
    name: string;
    rarity: ItemRarity;
    description?: string;
    health?: number;
    attack?: number;
    armor?: number;
    speed?: number;
    isWeapon?: boolean;
    tags?: ItemTag[];
    components?: ItemName[];
    itemPool?: ItemPool;
    warning?: boolean;
};
enum Color {
    Health = '#95C540',
    Attack = '#E74444',
    Speed = '#FFD368',
    Stun = '#FFD368',
    Armor = '#62A9D3',
    Purity = '#62A9D3',
    Freeze = '#62A9D3',
    Thorns = '#89951F',
    Riptide = '#587FCB',
    Acid = '#CBF51F',
    Poison = '#B9C34E',
    Regeneration = '#994C50',
}
export const ITEM_STATS: Record<ItemName, ItemStats> = {
    [ItemName.Empty]: {
        name: '',
        rarity: ItemRarity.None,
        itemPool: ItemPool.Unobtainable,
    },
    [ItemName.Unknown]: {
        name: 'Unknown',
        description: `Item is not yet added to the website due to time and/or missing item information`,
        rarity: ItemRarity.None,
        itemPool: ItemPool.Unobtainable,
    },
    [ItemName.Any_Ring]: {
        name: 'Any Ring',
        rarity: ItemRarity.None,
        itemPool: ItemPool.Unobtainable,
    },
    [ItemName.Jagged_Edge]: {
        name: 'Jagged Edge',
        description: `On Hit: Gain 2 <span style="color:${Color.Thorns}">thorns</span> and take 1 damage`,
        rarity: ItemRarity.None,
        itemPool: ItemPool.Unobtainable, // Woodland 2
    },
    // [ItemName.Hardboiled_Egg]: {
    //     name: 'Hardboiled Egg',
    //     armor: 2,
    //     rarity: ItemRarity.Common,
    //     tags: [ItemTag.Food],
    //     itemPool: ItemPool.Easter,
    // },
    [ItemName.Boom_Stick]: {
        name: 'Boom Stick',
        isWeapon: true,
        attack: 1,
        description: `On Hit: Deal 2 damage`,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Bomb],
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Brittlebark_Club]: {
        name: 'Brittlebark Club',
        isWeapon: true,
        attack: 7,
        description: `Exposed & Wounded: Lose 2 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Razorthorn_Spear]: {
        name: 'Razorthorn Spear',
        isWeapon: true,
        attack: 1,
        description: `On Hit: Gain 2 <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Evergrowth_Spear]: {
        name: 'Evergrowth Spear',
        isWeapon: true,
        attack: 3,
        description: `Every other turn, gain 1 <span style="color:${Color.Attack}">attack</span> and restore 1 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Mushroom_Buckler]: {
        name: 'Mushroom Buckler',
        armor: 3,
        description: `If you have <span style="color:${Color.Poison}">poison</span>, enemy strikes deal 1 less damage`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Fungal_Rapier]: {
        name: 'Fungal Rapier',
        isWeapon: true,
        attack: 3,
        description: `Battle Start: Gain 1 <span style="color:${Color.Poison}">poison</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Leather_Whip]: {
        name: 'Leather Whip',
        isWeapon: true,
        attack: 4,
        health: 5,
        description: `Battle Start: Gain 5 max <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Pacifist_Staff]: {
        name: 'Pacifist Staff',
        isWeapon: true,
        attack: 0,
        description: `On Hit: Gain 1 <span style="color:${Color.Armor}">armor</span> and restore 1 <span style="color:${Color.Health}">health</span>`,
        tags: [ItemTag.Wood],
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Silverscale_Trident]: {
        name: 'Silverscale Trident',
        isWeapon: true,
        attack: 0,
        description: `On Hit: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Ironstone_Greatsword]: {
        name: 'Ironstone Greatsword',
        isWeapon: true,
        attack: 4,
        speed: -2,
        tags: [ItemTag.Stone],
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    // [ItemName.Citrine_Gemstone]: {
    //     name: 'Citrine Gemstone',
    //     speed: -5,
    //     description: `Your base <span style="color:${Color.Speed}">speed</span> stat is inverted`,
    //     rarity: ItemRarity.Heroic,
    //     tags: [ItemTag.Jewelry],
    //     itemPool: ItemPool.Woodland_2,
    // },
    [ItemName.Seasonal_Pumpkin]: {
        name: 'Seasonal Pumpkin',
        description: `Battle Start: Steal 1 <span style="color:${Color.Attack}">attack</span> from the enemy`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Halloween,
    },
    [ItemName.Bloodwine_Gourd]: {
        name: 'Bloodwine Gourd',
        description: `Wounded: Steal 50% of the enemy's current <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Vampiric_Wine, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Petrified_Pumpkin]: {
        name: 'Petrified Pumpkin',
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, steal all of the enemy's <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Stone_Steak, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Explosive_Pumpkin]: {
        name: 'Explosive Pumpkin',
        description: `Battle Start: Deal 1 damage 2 times and steal that much <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Cherry_Bomb, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Roasted_Pumpkin]: {
        name: 'Roasted Pumpkin',
        description: `Battle Start: Steal 2 <span style="color:${Color.Attack}">attack</span> from the enemy`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Wood],
        components: [ItemName.Redwood_Roast, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Prickly_Pumpkin]: {
        name: 'Prickly Pumpkin',
        description: `Battle Start: Gain 5 <span style="color:${Color.Thorns}">thorns</span>. Whenever the enemy loses <span style="color:${Color.Armor}">armor</span> to <span style="color:${Color.Thorns}">thorns</span>, gain that <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Poisonous_Pumpkin]: {
        name: 'Poisonous Pumpkin',
        description: `Battle Start: Gain 3 <span style="color:${Color.Poison}">poison</span>. Whenever you take damage from <span style="color:${Color.Poison}">poison</span>, steal 1 <span style="color:${Color.Attack}">attack</span> from the enemy`,
        attack: 2,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Poisonous_Mushroom, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Pickled_Pumpkin]: {
        name: 'Pickled Pumpkin',
        description: `Battle Start: Steal 2 <span style="color:${Color.Attack}">attack</span> from the enemy and gain 2 <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Sour_Lemon, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Pumpkin_Pie]: {
        name: 'Pumpkin Pie',
        description: `Battle Start: Steal all <span style="color:${Color.Attack}">attack</span> from the enemy`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Pumpkin_Lance]: {
        name: 'Pumpkin Lance',
        description: `Every 3 strikes, steal 1 <span style="color:${Color.Attack}">attack</span> from the enemy`,
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Grilling_Skewer, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Buoyant_Pumpkin]: {
        name: 'Buoyant Pumpkin',
        description: `Exposed: Steal 2 <span style="color:${Color.Attack}">attack</span> from the enemy and give them 2 <span style="color:${Color.Riptide}">riptide</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Silverscale_Fish, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Swan_Gourd]: {
        name: 'Swan Gourd',
        description: `Battle Start, Exposed & Wounded: Decrease 1 random status effect by 1 and steal 1 <span style="color:${Color.Attack}">attack</span> from the enemy`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Water],
        components: [ItemName.Clearspring_Watermelon, ItemName.Seasonal_Pumpkin]
    },
    [ItemName.Redwood_Roast]: {
        name: 'Redwood Roast',
        rarity: ItemRarity.Common,
        health: 5,
        tags: [ItemTag.Wood, ItemTag.Food],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Cherry_Bomb]: {
        name: 'Cherry Bomb',
        rarity: ItemRarity.Common,
        description: `Battle Start: Deal 1 damage 2 times`,
        tags: [ItemTag.Bomb, ItemTag.Food],
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Spiny_Chestnut]: {
        name: 'Spiny Chestnut',
        rarity: ItemRarity.Common,
        description: `Battle Start: Gain 3 <span style="color:${Color.Thorns}">thorns</span>`,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Stone_Steak]: {
        name: 'Stone Steak',
        rarity: ItemRarity.Rare,
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, gain 5 <span style="color:${Color.Armor}">armor</span>`,
        tags: [ItemTag.Stone, ItemTag.Food],
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Vampiric_Wine]: {
        name: 'Vampiric Wine',
        rarity: ItemRarity.Common,
        description: `Wounded: Restore 4 <span style="color:${Color.Health}">health</span>`,
        tags: [ItemTag.Sanguine, ItemTag.Food],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Silverscale_Fish]: {
        name: 'Silverscale Fish',
        rarity: ItemRarity.Common,
        description: `Exposed: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span>`,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Clearspring_Watermelon]: {
        name: 'Clearspring Watermelon',
        rarity: ItemRarity.Common,
        description: `Battle Start, Exposed & Wounded: Decrease a random status effect by 1`,
        tags: [ItemTag.Water, ItemTag.Food],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Sour_Lemon]: {
        name: 'Sour Lemon',
        rarity: ItemRarity.Common,
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Poisonous_Mushroom]: {
        name: 'Poisonous Mushroom',
        rarity: ItemRarity.Rare,
        description: `Turn Start: Gain 1 <span style="color:${Color.Poison}">poison</span>`,
        attack: 2,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Grilling_Skewer]: {
        name: 'Grilling Skewer',
        rarity: ItemRarity.Common,
        description: `Battle Start: Gain 1 additional strike`,
        attack: 1,
        isWeapon: true,
        tags: [ItemTag.Food],
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Honeycomb]: {
        name: 'Honeycomb',
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Food],
    },
    [ItemName.Bee_Stinger]: {
        name: 'Bee Stinger',
        rarity: ItemRarity.Food,
        description: `First Turn: Give the enemy 4 <span style="color:${Color.Poison}">poison</span>, 3 <span style="color:${Color.Acid}">acid</span> and 2 <span style="color:${Color.Stun}">stun</span> on hit`,
        attack: 3,
        isWeapon: true,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Grilling_Skewer],
    },
    [ItemName.Bitter_Melon]: {
        name: 'Bitter Melon',
        description: `Turn Start: Convert 1 stack of another status effect to 1 <span style="color:${Color.Poison}">poison</span>`,
        attack: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Clearspring_Watermelon, ItemName.Poisonous_Mushroom],
    },
    [ItemName.Blackbriar_Bow]: {
        name: 'Blackbriar Bow',
        description: `Can't strike. Turn Start: Gain <span style="color:${Color.Thorns}">thorns</span> equal to your <span style="color:${Color.Attack}">attack</span>`,
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Grilling_Skewer, ItemName.Spiny_Chestnut],
    },
    [ItemName.Blood_Orange]: {
        name: 'Blood Orange',
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span>. Wounded: Restore 4 <span style="color:${Color.Health}">health</span> for each <span style="color:${Color.Acid}">acid</span> you have`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Sour_Lemon, ItemName.Vampiric_Wine],
    },
    [ItemName.Blood_Sausage]: {
        name: 'Blood Sausage',
        description: `Wounded: Restore 1 <span style="color:${Color.Health}">health</span> 5 times`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Redwood_Roast, ItemName.Vampiric_Wine],
    },
    [ItemName.Bloody_Steak]: {
        name: 'Bloody Steak',
        description: `Wounded: Restore 10 <span style="color:${Color.Health}">health</span> and gain 10 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Vampiric_Wine, ItemName.Stone_Steak],
    },
    [ItemName.Boiled_Ham]: {
        name: 'Boiled Ham',
        description: `Battle Start, Exposed & Wounded: Decrease a random status effect by 2`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Water],
        components: [ItemName.Clearspring_Watermelon, ItemName.Redwood_Roast],
    },
    [ItemName.Broken_Winebottle]: {
        name: 'Broken Winebottle',
        description: `Wounded: Restore 4 <span style="color:${Color.Health}">health</span> and gain 4 additional strikes`,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Grilling_Skewer, ItemName.Vampiric_Wine],
    },
    [ItemName.Candied_Nuts]: {
        name: 'Candied Nuts',
        description: `Your <span style="color:${Color.Thorns}">thorns</span> deal double damage`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Spiny_Chestnut],
    },
    // [ItemName.Cherry_Blade]: {
    //     name: 'Cherry Blade',
    //     description: `Battle Start & Exposed: Deal 4 damage`,
    //     attack: 3,
    //     isWeapon: true,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Bomb],
    //     components: [ItemName.Cherry_Bomb, ItemName.Grilling_Skewer],
    // },
    [ItemName.Cherrytree_Branch]: {
        name: 'Cherrytree Branch',
        description: `Can't Strike. Turn Start: Deal 1 damage 1 time. Increase the number of times this triggers by 1 each turn`,
        attack: 0,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Cherry_Bomb, ItemName.Grilling_Skewer],
    },
    [ItemName.Cherry_Cocktail]: {
        name: 'Cherry Cocktail',
        description: `Battle Start & Wounded: Deal 3 damage and restore 3 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb, ItemTag.Sanguine],
        components: [ItemName.Cherry_Bomb, ItemName.Vampiric_Wine],
    },
    [ItemName.Combustible_Lemon]: {
        name: 'Combustible Lemon',
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span>. At the start of your third turn, deal damage equal to your <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Sour_Lemon, ItemName.Cherry_Bomb],
    },
    [ItemName.Deathcap_Bow]: {
        name: 'Deathcap Bow',
        description: `Battle Start: Gain 3 <span style="color:${Color.Poison}">poison</span>. Turn Start: If you have <span style="color:${Color.Poison}">poison</span>, gain 1 additional strike`,
        attack: 5,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Grilling_Skewer, ItemName.Poisonous_Mushroom],
    },
    // [ItemName.Deepsea_Wine]: {
    //     name: 'Deepsea Wine',
    //     description: `Wounded: Give the enemy 2 <span style="color:${Color.Riptide}">riptide</span>. Whenever <span style="color:${Color.Riptide}">riptide</span> triggers, restore 3 <span style="color:${Color.Health}">health</span>`,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Silverscale_Fish, ItemName.Vampiric_Wine],
    // },
    [ItemName.Crimson_Fish]: {
        name: 'Crimson Fish',
        description: `Wounded: Give the enemy 2 <span style="color:${Color.Riptide}">riptide</span>. Whenever <span style="color:${Color.Riptide}">riptide</span> triggers, restore 3 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Silverscale_Fish, ItemName.Vampiric_Wine],
    },
    [ItemName.Explosive_Fish]: {
        name: 'Explosive Fish',
        description: `Battle Start: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span>. Whenever <span style="color:${Color.Riptide}">riptide</span> triggers, deal 1 damage`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Cherry_Bomb, ItemName.Silverscale_Fish],
    },
    [ItemName.Explosive_Roast]: {
        name: 'Explosive Roast',
        description: `Battle Start: Deal 1 damage 3 times`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Cherry_Bomb, ItemName.Redwood_Roast],
    },
    // [ItemName.Granite_Cherry]: {
    //     name: 'Granite Cherry',
    //     description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, gain 2 <span style="color:${Color.Armor}">armor</span> and deal 2 damage. Repeat 2 times`,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Stone, ItemTag.Bomb],
    //     components: [ItemName.Cherry_Bomb, ItemName.Stone_Steak],
    // },
    [ItemName.Cherry_Steak]: {
        name: 'Cherry Steak',
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, deal 1 damage 5 times. Otherwise gain 10 <span style="color:${Color.Armor}">armor</span> instead`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Cherry_Bomb, ItemName.Stone_Steak],
    },
    [ItemName.Ham_Bat]: {
        name: 'Ham Bat',
        description: `Battle Start: Gain 2 additional strikes`,
        health: 5,
        attack: 4,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Wood],
        components: [ItemName.Redwood_Roast, ItemName.Grilling_Skewer],
    },
    [ItemName.Honey_Caviar]: {
        name: 'Honey Caviar',
        description: `Exposed: Give the enemy 10 <span style="color:${Color.Riptide}">riptide</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Silverscale_Fish],
    },
    [ItemName.Honey_Glazed_Shroom]: {
        name: 'Honey-glazed Shroom',
        description: `Turn Start: Give the enemy 2 <span style="color:${Color.Poison}">poison</span>`,
        attack: 4,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Poisonous_Mushroom],
    },
    [ItemName.Honey_Ham]: {
        name: 'Honey Ham',
        description: `Double your max <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Redwood_Roast],
    },
    [ItemName.Honeydew_Melon]: {
        name: 'Honeydew Melon',
        description: `Battle Start: Give all your status effects to the enemy`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Clearspring_Watermelon],
    },
    [ItemName.Melon_Seeds]: {
        name: 'Melon Seeds',
        description: `Battle Start, Exposed & Wounded: Decrease a random status effect by 3 and gain 1 <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Clearspring_Watermelon],
    },
    [ItemName.Lemon_Roast]: {
        name: 'Lemon Roast',
        description: `Battle Start: Gain 2 <span style="color:${Color.Acid}">acid</span>`,
        health: 5,
        speed: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Sour_Lemon, ItemName.Redwood_Roast],
    },
    [ItemName.Lemon_Shark]: {
        name: 'Lemon Shark',
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span>. Exposed: Give the enemy <span style="color:${Color.Riptide}">riptide</span> equal to your <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Sour_Lemon, ItemName.Silverscale_Fish],
    },
    [ItemName.Lemon_Syrup]: {
        name: 'Lemon Syrup',
        description: `Battle Start: Double your <span style="color:${Color.Speed}">speed</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Sour_Lemon],
    },
    [ItemName.Lemontree_Branch]: {
        name: 'Lemontree Branch',
        description: `On Hit: Spend 2 <span style="color:${Color.Speed}">speed</span> and gain 1 additional strike on your next turn`,
        attack: 2,
        speed: 3,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Wood],
        components: [ItemName.Grilling_Skewer, ItemName.Sour_Lemon],
    },
    [ItemName.Limestone_Fruit]: {
        name: 'Limestone Fruit',
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span> and 8 <span style="color:${Color.Armor}">armor</span>. If your <span style="color:${Color.Health}">health</span> is full, gain 2 <span style="color:${Color.Acid}">acid</span> and 16 <span style="color:${Color.Armor}">armor</span> instead`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Sour_Lemon, ItemName.Stone_Steak],
    },
    [ItemName.Marble_Mushroom]: {
        name: 'Marble Mushroom',
        description: `Turn Start: Gain 1 <span style="color:${Color.Poison}">poison</span> and 3 <span style="color:${Color.Armor}">armor</span>`,
        attack: 4,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Stone_Steak, ItemName.Poisonous_Mushroom],
    },
    [ItemName.Marbled_Stonefish]: {
        name: 'Marbled Stonefish',
        description: `Exposed: Give the enemy 2 <span style="color:${Color.Riptide}">riptide</span> and gain 3 <span style="color:${Color.Armor}">armor</span> for each <span style="color:${Color.Riptide}">riptide</span> the enemy has`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Stone_Steak, ItemName.Silverscale_Fish],
    },
    [ItemName.Melon_Bomb]: {
        name: 'Melon Bomb',
        description: `Battle Start: Deal 1 damage to the enemy 2 times. Whenever you deal 1 damage, decrease a random status effect by 1`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb, ItemTag.Water],
        components: [ItemName.Clearspring_Watermelon, ItemName.Cherry_Bomb],
    },
    [ItemName.Melon_Lemonade]: {
        name: 'Melon Lemonade',
        description: `Battle Start, Exposed & Wounded: Remove all your <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Clearspring_Watermelon, ItemName.Sour_Lemon],
    },
    [ItemName.Melon_Sangria]: {
        name: 'Melon Sangria',
        description: `Battle Start: Decrease a random status effect by 1. Whenever a status effect is decreased, restore 1 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Clearspring_Watermelon, ItemName.Vampiric_Wine],
    },
    [ItemName.Melonvine_Whip]: {
        name: 'Melonvine Whip',
        description: `Battle Start: Gain 1 additional strike. On Hit: Decrease 1 random status effect`,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Water],
        components: [ItemName.Clearspring_Watermelon, ItemName.Grilling_Skewer],
    },
    [ItemName.Mineral_Water]: {
        name: 'Mineral Water',
        description: `Battle Start: Decrease your status effects by 1 and gain 5 <span style="color:${Color.Armor}">armor</span> for each removed status effect`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Water],
        components: [ItemName.Clearspring_Watermelon, ItemName.Stone_Steak],
    },
    [ItemName.Moldy_Meat]: {
        name: 'Moldy Meat',
        health: -5,
        attack: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Redwood_Roast, ItemName.Poisonous_Mushroom],
    },
    [ItemName.Mushroom_Soup]: {
        name: 'Mushroom Soup',
        description: `Turn Start: Gain 2 <span style="color:${Color.Poison}">poison</span> and restore 5 <span style="color:${Color.Health}">health</span>`,
        attack: 2,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Sanguine],
        components: [ItemName.Poisonous_Mushroom, ItemName.Vampiric_Wine],
    },
    [ItemName.Petrified_Chestnut]: {
        name: 'Petrified Chestnut',
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, gain 10 <span style="color:${Color.Thorns}">thorns</span> and 10 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Spiny_Chestnut, ItemName.Stone_Steak],
    },
    [ItemName.Poisonous_Durian]: {
        name: 'Poisonous Durian',
        description: `Battle Start: Gain 2 <span style="color:${Color.Poison}">poison</span>. Whenever you take damage from <span style="color:${Color.Poison}">poison</span>, gain 3 <span style="color:${Color.Thorns}">thorns</span>`,
        attack: 2,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Poisonous_Mushroom, ItemName.Spiny_Chestnut],
    },
    [ItemName.Poisonous_Lemon]: {
        name: 'Poisonous Lemon',
        description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span> and 5 <span style="color:${Color.Poison}">poison</span>`,
        attack: 3,
        speed: 4,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Poisonous_Mushroom, ItemName.Sour_Lemon],
    },
    [ItemName.Poisonous_Pufferfish]: {
        name: 'Poisonous Pufferfish',
        description: `Battle Start: Gain 3 <span style="color:${Color.Poison}">poison</span> and give the enemy <span style="color:${Color.Riptide}">riptide</span> equal to your <span style="color:${Color.Poison}">poison</span>`,
        attack: 2,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Silverscale_Fish, ItemName.Poisonous_Mushroom],
    },
    [ItemName.Roasted_Chestnut]: {
        name: 'Roasted Chestnut',
        description: `Battle Start: Gain 5 <span style="color:${Color.Thorns}">thorns</span>`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Redwood_Roast],
    },
    [ItemName.Rock_Candy]: {
        name: 'Rock Candy',
        description: `Battle Start: Gain 20 <span style="color:${Color.Armor}">armor</span>. If your <span style="color:${Color.Health}">health</span> is full, gain an additional 30 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Stone_Steak],
    },
    [ItemName.Rock_Roast]: {
        name: 'Rock Roast',
        health: 5,
        armor: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Stone],
        components: [ItemName.Redwood_Roast, ItemName.Stone_Steak],
    },
    [ItemName.Rocksalt_Sword]: {
        name: 'Rocksalt Sword',
        description: `On Hit: If your <span style="color:${Color.Health}">health</span> is full, gain 3 <span style="color:${Color.Armor}">armor</span>`,
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Grilling_Skewer, ItemName.Stone_Steak],
    },
    [ItemName.Shark_Roast]: {
        name: 'Shark Roast',
        description: `Exposed: Give the enemy 2 <span style="color:${Color.Riptide}">riptide</span>`,
        health: 5,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Silverscale_Fish, ItemName.Redwood_Roast],
    },
    [ItemName.Silverscale_Swordfish]: {
        name: 'Silverscale Swordfish',
        description: `Battle Start: Gain 1 additional strike. First Turn: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span> on hit`,
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Grilling_Skewer, ItemName.Silverscale_Fish],
    },
    [ItemName.Spiked_Wine]: {
        name: 'Spiked Wine',
        description: `Wounded: Restore 5 <span style="color:${Color.Health}">health</span> and gain 5 <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Vampiric_Wine],
    },
    [ItemName.Spiny_Kiwifruit]: {
        name: 'Spiny Kiwifruit',
        description: `Battle Start: Gain 2 <span style="color:${Color.Acid}">acid</span> and gain <span style="color:${Color.Thorns}">thorns</span> equal to <span style="color:${Color.Acid}">acid</span>`,
        speed: 3,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Sour_Lemon],
    },
    [ItemName.Spiny_Snapper]: {
        name: 'Spiny Fish',
        description: `Battle Start: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span>. Whenever <span style="color:${Color.Riptide}">riptide</span> triggers, gain 3 <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Spiny_Chestnut, ItemName.Silverscale_Fish],
    },
    [ItemName.Sugar_Bomb]: {
        name: 'Sugar Bomb',
        description: `Turn Start: Deal 1 damage 3 times`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Honeycomb, ItemName.Cherry_Bomb],
    },
    [ItemName.Honey_Mead]: {
        name: 'Honey Mead',
        description: `Wounded: Restore <span style="color:${Color.Health}">health</span> to full and restore 1 <span style="color:${Color.Health}">health</span> at Turn Start for the rest of battle`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Honeycomb, ItemName.Vampiric_Wine],
    },
    // [ItemName.Toxic_Cherry]: {
    //     name: 'Toxic Cherry',
    //     description: `Turn Start: Gain 1 <span style="color:${Color.Poison}">poison</span> and deal 1 damage to the enemy`,
    //     attack: 3,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Bomb],
    //     components: [ItemName.Poisonous_Mushroom, ItemName.Cherry_Bomb],
    // },
    [ItemName.Twin_Mushroom]: {
        name: 'Twin Mushroom',
        description: `Battle Start: Deal 1 damage 2 times. Whenever a bomb deals non-weapon damage, give the enemy 1 <span style="color:${Color.Poison}">poison</span>`,
        attack: 2,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Poisonous_Mushroom, ItemName.Cherry_Bomb],
    },
    [ItemName.Trail_Mix]: {
        name: 'Trail Mix',
        description: `Battle Start: Deal 1 damage 3 times and gain 1 <span style="color:${Color.Thorns}">thorn</span> 3 times`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food, ItemTag.Bomb],
        components: [ItemName.Spiny_Chestnut, ItemName.Cherry_Bomb],
    },
    [ItemName.Underwater_Watermelon]: {
        name: 'Silverscale Melon',
        description: `Battle Start, Exposed & Wounded: Decrease 1 random status effect, if you do, give the enemy 2 <span style="color:${Color.Riptide}">riptide</span>`,
        rarity: ItemRarity.Food,
        tags: [ItemTag.Food],
        components: [ItemName.Silverscale_Fish, ItemName.Clearspring_Watermelon],
    },
    // <span style="color:${Color.}"></span>
    // [ItemName.Baked_Egg]: {
    //     name: 'Baked Egg',
    //     health: 5,
    //     armor: 5,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Wood],
    //     components: [ItemName.Redwood_Roast, ItemName.Hardboiled_Egg],
    // },
    // [ItemName.Creme_Brulee]: {
    //     name: 'Creme Brulee',
    //     description: `Your base <span style="color:${Color.Armor}">armor</span> is doubled`,
    //     armor: 2,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Honeycomb],
    // },
    // [ItemName.Eggnog]: {
    //     name: 'Eggnog',
    //     description: `Exposed & Wounded: Restore 3 <span style="color:${Color.Health}">heatlh</span>`,
    //     armor: 2,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Vampiric_Wine],
    // },
    // [ItemName.Explosive_Egg]: {
    //     name: 'Explosive Egg',
    //     description: `Battle Start: Deal 4 damage to yourself and the enemy 2 times`,
    //     armor: 2,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Bomb],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Cherry_Bomb],
    // },
    // [ItemName.Fish_Egg]: {
    //     name: 'Fish Egg',
    //     description: `Exposed: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span>`,
    //     armor: 4,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Silverscale_Fish],
    // },
    // [ItemName.Frying_Pan]: {
    //     name: 'Frying Pan',
    //     description: `Exposed: Gain 3 additional strikes`,
    //     attack: 3,
    //     armor: 2,
    //     isWeapon: true,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Grilling_Skewer],
    // },
    // [ItemName.Pickled_Egg]: {
    //     name: 'Pickled Egg',
    //     description: `Battle Start: Gain 1 <span style="color:${Color.Acid}">acid</span>. Whenever you lose <span style="color:${Color.Armor}">armor</span> to <span style="color:${Color.Acid}">acid</span>, gain 1 <span style="color:${Color.Speed}">speed</span>`,
    //     armor: 2,
    //     speed: 3,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Sour_Lemon],
    // },
    // [ItemName.Melon_Egg]: {
    //     name: 'Melon Egg',
    //     description: `Battle Start, Exposed & Wounded: Spend 1 <span style="color:${Color.Armor}">armor</span> to decrease a status effect by 3`,
    //     armor: 2,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Water],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Clearspring_Watermelon],
    // },
    // [ItemName.Rotten_Egg]: {
    //     name: 'Rotten Egg',
    //     description: `Turn Start: Gain 1 <span style="color:${Color.Armor}">armor</span> and 2 <span style="color:${Color.Poison}">poison</span>`,
    //     armor: 3,
    //     attack: 3,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Poisonous_Mushroom],
    // },
    // [ItemName.Spiky_Egg]: {
    //     name: 'Spiky Egg',
    //     description: `Exposed: Gain 5 <span style="color:${Color.Thorns}">thorns</span>`,
    //     armor: 2,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Spiny_Chestnut],
    // },
    // [ItemName.Stone_Egg]: {
    //     name: 'Stone Egg',
    //     armor: 10,
    //     rarity: ItemRarity.Food,
    //     tags: [ItemTag.Food, ItemTag.Stone],
    //     components: [ItemName.Hardboiled_Egg, ItemName.Stone_Steak],
    // },
    [ItemName.Lightspeed_Potion]: {
        name: 'Lightspeed Potion',
        description: `Battle Start: Restore 1 <span style="color:${Color.Health}">health</span> for each <span style="color:${Color.Speed}">speed</span> you have`,
        speed: 1,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
        tags: [ItemTag.Potion],
    },
    [ItemName.Muscle_Potion]: {
        name: 'Muscle Potion',
        description: `Every 3 strikes: Gain 1 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Potion],
    },
    [ItemName.Petrifying_Flask]: {
        name: 'Petrifying Flask',
        description: `Wounded: Gain 10 <span style="color:${Color.Armor}">armor</span> and <span style="color:${Color.Stun}">stun</span> yourself for 2 turns`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion, ItemTag.Stone],
    },
    [ItemName.Heart_Shaped_Potion]: {
        name: 'Heart-shaped Potion',
        description: `When you are reduced to exactly 1 <span style="color:${Color.Health}">health</span> for the first time, restore <span style="color:${Color.Health}">health</span> to full`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_3,
        tags: [ItemTag.Potion, ItemTag.Sanguine],
    },
    [ItemName.Lightning_Bottle]: {
        name: 'Lightning Bottle',
        description: `Battle Start: <span style="color:${Color.Stun}">Stun</span> yourself for 1 turn`,
        attack: 1,
        speed: 2,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion],
    },
    [ItemName.Nerve_Poison]: {
        name: 'Nerve Poison',
        description: `The first time the enemy gains <span style="color:${Color.Poison}">poison</span>, <span style="color:${Color.Stun}">stun</span> them for 1 turn`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Potion],
    },
    [ItemName.Purelake_Potion]: {
        name: 'Purelake Potion',
        description: `Battle start: Remove all your <span style="color:${Color.Armor}">armor</span> and gain 3 <span style="color:${Color.Purity}">purity</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion, ItemTag.Water],
    },
    [ItemName.Slime_Potion]: {
        name: 'Slime Potion',
        description: `Wounded: Gain <span style="color:${Color.Armor}">armor</span> equal to lost <span style="color:${Color.Health}">health</span> and gain 5 <span style="color:${Color.Acid}">acid</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion],
    },
    [ItemName.Viper_Extract]: {
        name: 'Viper Extract',
        description: `The first time the enemy gains <span style="color:${Color.Poison}">poison</span>, give them 3 additional <span style="color:${Color.Poison}">poison</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Potion],
    },
    [ItemName.Ironskin_Potion]: {
        name: 'Ironskin Potion',
        description: `Battle Start: Gain <span style="color:${Color.Armor}">armor</span> equal to lost <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_1,
        tags: [ItemTag.Potion],
    },
    [ItemName.Lightspeed_Elixir]: {
        name: 'Lightspeed Elixir',
        description: `Battle Start: Gain 1 max <span style="color:${Color.Health}">health</span> for each <span style="color:${Color.Speed}">speed</span> that you have and then restore that much <span style="color:${Color.Health}">health</span>`,
        speed: 1,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
        tags: [ItemTag.Potion],
        components: [ItemName.Lightspeed_Potion]
    },
    [ItemName.Muscle_Elixir]: {
        name: 'Muscle Elixir',
        description: `Every 3 strikes: Gain 1 <span style="color:${Color.Attack}">attack</span>, 1 <span style="color:${Color.Armor}">armor</span> and 1 <span style="color:${Color.Speed}">speed</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion],
        components: [ItemName.Muscle_Potion]
    },
    [ItemName.Petrifying_Elixir]: {
        name: 'Petrifying Elixir',
        description: `Wounded: Gain 10 <span style="color:${Color.Armor}">armor</span> and <span style="color:${Color.Stun}">stun</span> yourself and the enemy for 2 turns`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion, ItemTag.Stone],
        components: [ItemName.Petrifying_Flask]
    },
    [ItemName.Heart_Shaped_Elixir]: {
        name: 'Heart-shaped Elixir',
        description: `When you are reduced below 5 <span style="color:${Color.Health}">health</span> for the first time, restore <span style="color:${Color.Health}">health</span> to full`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_3,
        tags: [ItemTag.Potion, ItemTag.Sanguine],
        components: [ItemName.Heart_Shaped_Potion]
    },
    [ItemName.Lightning_Elixir]: {
        name: 'Lightning Elixir',
        description: `Battle Start: <span style="color:${Color.Stun}">Stun</span> yourself for 2 turns`,
        attack: 3,
        speed: 4,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion],
        components: [ItemName.Lightning_Bottle]
    },
    [ItemName.Nerve_Elixir]: {
        name: 'Nerve Elixir',
        description: `The first time the enemy gains <span style="color:${Color.Poison}">poison</span>, <span style="color:${Color.Stun}">stun</span> them for 3 turns`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Potion],
        components: [ItemName.Nerve_Poison]
    },
    [ItemName.Purelake_Elixir]: {
        name: 'Purelake Elixir',
        description: `Battle Start: Lose 5 <span style="color:${Color.Armor}">armor</span> and gain 5 <span style="color:${Color.Purity}">purity</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion, ItemTag.Water],
        components: [ItemName.Purelake_Potion]
    },
    [ItemName.Slime_Elixir]: {
        name: 'Slime Elixir',
        description: `Wounded: Gain <span style="color:${Color.Armor}">armor</span> equal to max <span style="color:${Color.Health}">health</span> and gain 5 <span style="color:${Color.Acid}">acid</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Potion],
        components: [ItemName.Slime_Potion]
    },
    [ItemName.Viper_Elixir]: {
        name: 'Viper Elixir',
        description: `The first time the enemy gains <span style="color:${Color.Poison}">poison</span>, give them 9 additional <span style="color:${Color.Poison}">poison</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Potion],
        components: [ItemName.Viper_Extract]
    },
    [ItemName.Ironskin_Elixir]: {
        name: 'Ironskin Elixir',
        description: `Battle Start: Gain 20 max <span style="color:${Color.Health}">health</span> and gain <span style="color:${Color.Armor}">armor</span> equal to lost <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_1,
        tags: [ItemTag.Potion],
        components: [ItemName.Ironskin_Potion]
    },
    [ItemName.Wet_Egg]: {
        name: 'Clearspring Egg',
        description: `Hatches after you defeat the next boss if not in your pouch`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Water],
    },
    [ItemName.Deviled_Egg]: {
        name: 'Deviled Egg',
        description: `Hatches after you defeat the next boss if not in your pouch`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Sanguine],
    },
    [ItemName.Easter_Egg]: {
        name: 'Easter Egg',
        description: `Hatches after you defeat the next boss if not in your pouch`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Easter,
    },
    [ItemName.Granite_Egg]: {
        name: 'Granite Egg',
        description: `Hatches after you defeat the next boss if not in your pouch`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_3,
        tags: [ItemTag.Stone],
    },
    [ItemName.Treebark_Egg]: {
        name: 'Treebark Egg',
        description: `Hatches after you defeat the next boss if not in your pouch`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Wood],
    },
    [ItemName.Clearspring_Duck]: {
        name: 'Clearspring Duck',
        description: `Turn Start: Gain 1 <span style="color:${Color.Armor}">armor</span> and decrease a random status effect by 1`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_2,
        tags: [ItemTag.Water],
        components: [ItemName.Wet_Egg]
    },
    [ItemName.Sanguine_Imp]: {
        name: 'Sanguine Imp',
        description: `Turn Start: Deal 1 damage and restore 1 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Sanguine],
        components: [ItemName.Deviled_Egg]
    },
    [ItemName.Easter_Bunny]: {
        name: 'Easter Bunny',
        description: `Turn Start effects trigger 1 additional time`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Easter,
        components: [ItemName.Easter_Egg]
    },
    [ItemName.Liferoot_Beast]: {
        name: 'Treebark Creature',
        description: `Turn Start: If you don't have any <span style="color:${Color.Regeneration}">regeneration</span>, gain 3 <span style="color:${Color.Regeneration}">regeneration</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
        tags: [ItemTag.Wood],
        components: [ItemName.Treebark_Egg]
    },
    [ItemName.Stoneborn_Turtle]: {
        name: 'Stoneborn Turtle',
        description: `Turn Start: Restore 1 <span style="color:${Color.Health}">health</span>. If your <span style="color:${Color.Health}">health</span> is full, gain 2 <span style="color:${Color.Armor}">armor</span> instead`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_3,
        tags: [ItemTag.Stone],
        components: [ItemName.Granite_Egg]
    },
    [ItemName.Basilisk_Fang]: {
        name: 'Basilisk Fang',
        description: `On Hit: Decrease your <span style="color:${Color.Poison}">poison</span> by 2 and give it to the enemy`,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Basilisk_Scale]: {
        name: 'Basilisk Scale',
        description: `Battle Start: Gain 6 <span style="color:${Color.Armor}">armor</span> and 6 <span style="color:${Color.Poison}">poison</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Bloodmoon_Dagger]: {
        name: 'Bloodmoon Dagger',
        description: `Wounded: Gain 5 <span style="color:${Color.Attack}">attack</span> and take 2 damage`,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Swiftstrike_Gauntlet]: {
        name: 'Swiftstrike Gauntlet',
        description: `Wounded: Gain 2 additional strikes`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Assault_Greaves]: {
        name: 'Assault Greaves',
        description: `Whenever you lose <span style="color:${Color.Armor}">armor</span>, deal 1 damage`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Brittlebark_Bow]: {
        name: 'Brittlebark Bow',
        description: `After 3 strikes, lose 2 attack`,
        attack: 4,
        isWeapon: true,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Brittlebark_Buckler]: {
        name: 'Brittlebark Buckler',
        description: `Lose all your <span style="color:${Color.Armor}">armor</span> after your enemy's first strike`,
        armor: 15,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Brittlebark_Armor]: {
        name: 'Brittlebark Armor',
        description: `Whenever you lose <span style="color:${Color.Health}">health</span>, take 1 additional damage`,
        health: 12,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Champions_Armor]: {
        name: "Champion's Armor",
        armor: 6,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Champions_Blade]: {
        name: "Champion's Blade",
        attack: 6,
        isWeapon: true,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Elderwood_Staff]: {
        name: "Elderwood Staff",
        attack: 1,
        armor: 1,
        speed: 1,
        isWeapon: true,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Elderwood_Necklace]: {
        name: "Elderwood Necklace",
        attack: 1,
        armor: 1,
        speed: 1,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Sword_Of_The_Hero]: {
        name: "Sword of the Hero",
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Boots_Of_The_Hero]: {
        name: "Boots of the Hero",
        speed: 2,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Shield_Of_The_Hero]: {
        name: "Shield of the Hero",
        armor: 3,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Holy_Shield]: {
        name: "Holy Shield",
        armor: 6,
        speed: -1,
        attack: -1,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Holy_Tome]: {
        name: "Holy Tome",
        description: `Countdown 4: Gain 4 <span style="color:${Color.Attack}">attack</span>`,
        attack: -1,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Chainmail_Armor]: {
        name: "Chainmail Armor",
        description: `Wounded: Regain your base <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Chainmail_Sword]: {
        name: "Chainmail Sword",
        description: `Exposed: Gain <span style="color:${Color.Armor}">armor</span> equal to your base <span style="color:${Color.Armor}">armor</span>`,
        attack: 2,
        armor: 2,
        isWeapon: true,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Pinecone_Breastplate]: {
        name: "Pinecone Breastplate",
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, gain 1 <span style="color:${Color.Thorns}">thorn</span> at turn start for the rest of the battle`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Ironstone_Spear]: {
        name: "Ironstone Spear",
        description: `While you have <span style="color:${Color.Armor}">armor</span>, temporarily gain 2 <span style="color:${Color.Attack}">attack</span>`,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Ironstone_Sandals]: {
        name: "Ironstone Sandals",
        description: `While you have <span style="color:${Color.Armor}">armor</span>, temporarily gain 2 <span style="color:${Color.Attack}">attack</span>`,
        speed: -1,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Forge_Gauntlet]: {
        name: "Forge Gauntlet",
        description: `Battle Start: Give the enemy 6 <span style="color:${Color.Armor}">armor</span>`,
        attack: 2,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Forge_Hammer]: {
        name: "Forge Hammer",
        description: `On Hit: Give the enemy 2 <span style="color:${Color.Armor}">armor</span>`,
        attack: 4,
        isWeapon: true,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Crimson_Fang]: {
        name: "Crimson Fang",
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, lose 5 <span style="color:${Color.Health}">health</span> and gain 2 additional strikes`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Venomous_Fang]: {
        name: "Venomous Fang",
        description: `First Turn: Give the enemy 2 <span style="color:${Color.Poison}">poison</span> on hit`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_1,
    },
    // [ItemName.Ironstone_Bracelet]: {
    //     name: "Ironstone Bracelet",
    //     description: `<span style="color:${Color.Attack}">NOTE: This item supposedly got removed?</span><br/>Enemy strikes deal 1 damage less while you have <span style="color:${Color.Armor}">armor</span> but 1 damage more otherwise`,
    //     speed: -1,
    //     rarity: ItemRarity.Common,
    //     tags: [ItemTag.Stone],
    //     itemPool: ItemPool.Woodland_1,
    //     warning: true,
    // },
    [ItemName.Petrified_Statue]: {
        name: "Petrified Statue",
        description: `Battle Start: Give the enemy 1 <span style="color:${Color.Stun}">stun</span> for each equipped stone item`,
        speed: -2,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Iron_Transfusion]: {
        name: "Iron Transfusion",
        description: `Turn Start: Gain 2 <span style="color:${Color.Armor}">armor</span> and lose 1 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Lifeblood_Armor]: {
        name: "Lifeblood Armor",
        description: `Battle Start: Convert 50% of your current <span style="color:${Color.Health}">health</span> to that much <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Serpent_Lyre]: {
        name: "Serpent Lyre",
        description: `Exposed: Give the enemy 2 <span style="color:${Color.Poison}">poison</span>. Symphony`,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Instrument],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Marble_Sword]: {
        name: "Marble Sword",
        description: `Exposed: Gain 3 <span style="color:${Color.Attack}">attack</span>`,
        attack: 1,
        isWeapon: true,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Marshlight_Lantern]: {
        name: "Marshlight Lantern",
        description: `Exposed: Lose 5 <span style="color:${Color.Health}">health</span> and gain 15 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Riverflow_Violin]: {
        name: "Riverflow Violin",
        description: `Exposed: Gain 6 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Water, ItemTag.Instrument],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Leather_Boots]: {
        name: "Leather Boots",
        description: `Battle Start: If you have more <span style="color:${Color.Speed}">speed</span> than the enemy, gain 2 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Leather_Glove]: {
        name: "Leather Glove",
        health: 3,
        speed: 1,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Leather_Vest]: {
        name: "Leather Vest",
        armor: 2,
        speed: 1,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Redwood_Rod]: {
        name: "Redwood Rod",
        attack: 2,
        health: 4,
        isWeapon: true,
        tags: [ItemTag.Wood],
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Redwood_Helmet]: {
        name: "Redwood Helmet",
        description: `Exposed: Restore 3 <span style="color:${Color.Health}">health</span>`,
        armor: 1,
        health: 1,
        tags: [ItemTag.Wood],
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Redwood_Cloak]: {
        name: "Redwood Cloak",
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is not full, restore 2 <span style="color:${Color.Health}">health</span>`,
        health: 2,
        tags: [ItemTag.Wood],
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Saffron_Feather]: {
        name: "Saffron Feather",
        description: `Turn Start: If your <span style="color:${Color.Health}">health</span> is not full, spend 1 <span style="color:${Color.Speed}">speed</span> to restore 2 <span style="color:${Color.Health}">health</span>`,
        speed: 1,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Featherweight_Blade]: {
        name: "Featherweight Blade",
        speed: 2,
        attack: 2,
        isWeapon: true,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Sanguine_Scepter]: {
        name: "Sanguine Scepter",
        description: `Your healing is doubled`,
        attack: 1,
        isWeapon: true,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Granite_Gemstone]: {
        name: "Granite Gemstone",
        description: `If your <span style="color:${Color.Attack}">attack</span> is exactly 1, deal 4 damage on hit`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Spearshield_Lance]: {
        name: "Spearshield Lance",
        attack: 1,
        armor: 6,
        isWeapon: true,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Bramble_Buckler]: {
        name: "Bramble Buckler",
        description: `Turn Start: Convert 1 <span style="color:${Color.Armor}">armor</span> to 2 <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Moonlight_Crest]: {
        name: "Moonlight Crest",
        description: `Turn Start: If you're below 50% <span style="color:${Color.Health}">health</span>, gain 1 <span style="color:${Color.Regeneration}">regeneration</span>`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Sunlight_Crest]: {
        name: "Sunlight Crest",
        description: `Turn Start: If you're above 50% <span style="color:${Color.Health}">health</span>, lose 3 <span style="color:${Color.Health}">health</span> and gain 1 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Weaver_Armor]: {
        name: "Weaver Armor",
        description: `Battle Start: If you have 0 base <span style="color:${Color.Armor}">armor</span>, gain <span style="color:${Color.Armor}">armor</span> equal to your current <span style="color:${Color.Health}">health</span>`,
        attack: -2,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Weaver_Shield]: {
        name: "Weaver Shield",
        description: `Battle Start: If you have 0 base <span style="color:${Color.Armor}">armor</span>, gain 4 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Sanguine_Morphosis]: {
        name: "Sanguine Morphosis",
        description: `Every 4th Turn: <span style="color:${Color.Stun}">Stun</span> yourself for 1 turn and gain 3 <span style="color:${Color.Regeneration}">regeneration</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Vampiric_Stasis]: {
        name: "Vampiric Stasis",
        description: `Whenever you skip your strike, restore 3 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_2,
    },
    // [ItemName.Tome_Of_The_Hero]: {
    //     name: "Tome of the Hero",
    //     description: `Countdown 8: Gain 4 <span style="color:${Color.Attack}">attack</span>, 4 <span style="color:${Color.Armor}">armor</span> and 4 <span style="color:${Color.Speed}">speed</span>`,
    //     rarity: ItemRarity.Heroic,
    //     itemPool: ItemPool.Swampland_3,
    // },
    [ItemName.Silver_Arrow]: {
        name: "Silver Arrow",
        description: `First Turn: Your On Hit effects trigger 1 additional time`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Rusty_Sword]: {
        name: "Rusty Sword",
        description: `First Turn: Give <span style="color:${Color.Acid}">acid</span> equal to your <span style="color:${Color.Attack}">attack</span> on hit`,
        attack: 3,
        isWeapon: true,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Rusted_Plate]: {
        name: "Rusted Plate",
        description: `Whenever the enemy loses armor to acid, gain that armor`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Bloodlords_Axe]: {
        name: "Bloodlord's Axe",
        description: `Battle Start: Steal 5 <span style="color:${Color.Health}">health</span> from the enemy`,
        attack: 4,
        isWeapon: true,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Bloodstone_Ring]: {
        name: "Bloodstone Ring",
        description: `Battle Start: Gain 5 max <span style="color:${Color.Health}">health</span> and restore 5 <span style="color:${Color.Health}">health</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Sanguine],
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Stoneslab_Sword]: {
        name: "Stoneslab_Sword",
        isWeapon: true,
        attack: 2,
        description: `On Hit: Gain 2 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Serpent_Dagger]: {
        name: "Serpent Dagger",
        isWeapon: true,
        attack: 2,
        description: `On Hit: Give the enemy 2 <span style="color:${Color.Poison}">poison</span>`,
        rarity: ItemRarity.Heroic,
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Gale_Staff]: {
        name: "Gale Staff",
        isWeapon: true,
        attack: 2,
        speed: 6,
        description: `On Hit: Lose 1 <span style="color:${Color.Speed}">speed</span>`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_2,
    },
    [ItemName.Swiftstrike_Rapier]: {
        name: "Swiftstrike Rapier",
        isWeapon: true,
        attack: 2,
        description: `Battle Start: If you have more <span style="color:${Color.Speed}">speed</span> than the enemy, gain 3 additional strikes`,
        rarity: ItemRarity.Rare,
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Liferoot_Staff]: {
        name: "Liferoot Staff",
        isWeapon: true,
        attack: 2,
        description: `Wounded: Gain 3 <span style="color:${Color.Regeneration}">regeneration</span>`,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Frozen_Iceblade]: {
        name: "Frozen Iceblade",
        isWeapon: true,
        attack: 6,
        description: `Battle Start: Gain 3 <span style="color:${Color.Freeze}">freeze</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Water],
        itemPool: ItemPool.Woodland_2,
    },
    [ItemName.Melting_Iceblade]: {
        name: "Melting Iceblade",
        isWeapon: true,
        attack: 8,
        description: `On Hit: Lose 1 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Water],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Small_Kazoo]: {
        name: "Small Kazoo",
        description: `Battle Start: Trigger Symphony 1 time`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Swampland_3,
    },
    [ItemName.Liferoot_Banjo]: {
        name: "Liferoot Banjo",
        description: `Wounded: Gain 3 <span style="color:${Color.Regeneration}">regeneration</span>. Symphony`,
        rarity: ItemRarity.Heroic,
        tags: [ItemTag.Instrument,ItemTag.Wood],
        itemPool: ItemPool.Swampland_1,
    },
    [ItemName.Ore_Heart]: {
        name: "Ore Heart",
        description: `Battle Start: Gain 3 <span style="color:${Color.Armor}">armor</span> for each equipped stone item`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Stone],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Oak_Heart]: {
        name: "Oak Heart",
        description: `Gain 3 max <span style="color:${Color.Health}">health</span> for each equipped wood item`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Glacial_Spoon]: {
        name: "Glacial Spoon",
        isWeapon: true,
        attack: 1,
        description: `On Hit: Give the enemy 1 <span style="color:${Color.Freeze}">freeze</span>`,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Water],
        itemPool: ItemPool.Woodland_3,
    },
    [ItemName.Silver_Fork]: {
        name: "Silver Fork",
        isWeapon: true,
        attack: 1,
        description: `On Hit: Trigger a random common rartiy food item`,
        rarity: ItemRarity.Common,
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Woodcutters_Axe]: {
        name: "Woodcutters Axe",
        isWeapon: true,
        attack: 1,
        description: `Gain 2 attack for each empty equipment slot`,
        rarity: ItemRarity.Common,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Woodland_1,
    },
    [ItemName.Woodcutters_Boots]: {
        name: "Woodcutters Boots",
        description: `Battle Start: Gain 1 additional strike for each empty equipment slot`,
        rarity: ItemRarity.Rare,
        tags: [ItemTag.Wood],
        itemPool: ItemPool.Swampland_1,
    },
};

export const ITEM_SET_STATS: Record<ItemSetName, ItemStats> = {
    [ItemSetName.Agaric_Armor]: {
        name: "Agaric Armor",
        rarity: ItemRarity.Set,
        description: `Turn Start: Gain 1 <span style="color:${Color.Poison}">poison</span>. You cannot have more than 1 <span style="color:${Color.Poison}">poison</span>`,
        components: [ItemName.Fungal_Rapier, ItemName.Mushroom_Buckler]
    },
    [ItemSetName.Boom_Spear]: {
        name: "Boom Spear",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 1,
        description: `On Hit: Gain 2 <span style="color:${Color.Thorns}">thorns</span> and deal 2 damage`,
        tags: [ItemTag.Bomb],
        components: [ItemName.Boom_Stick, ItemName.Razorthorn_Spear]
    },
    [ItemSetName.Brittlebark_Blade]: {
        name: "Brittlebark Blade",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 12,
        description: `On Hit: Lose 2 <span style="color:${Color.Attack}">attack</span>`,
        tags: [ItemTag.Wood],
        components: [ItemName.Brittlebark_Bow, ItemName.Brittlebark_Club]
    },
    [ItemSetName.Spear_of_the_Hero]: {
        name: "Spear of the Hero",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 3,
        description: `Every other turn, gain 1 <span style="color:${Color.Attack}">attack</span> and restore 1 <span style="color:${Color.Health}">health</span>`,
        components: [ItemName.Sword_Of_The_Hero, ItemName.Evergrowth_Spear]
    },
    [ItemSetName.Bloodlords_Whip]: {
        name: "Bloodlord's Whip",
        rarity: ItemRarity.Set,
        attack: 4,
        health: 5,
        isWeapon: true,
        description: `Battle Start: Gain 5 max <span style="color:${Color.Health}">health</span> and steal 5 <span style="color:${Color.Health}">health</span> from the enemy`,
        tags: [ItemTag.Sanguine],
        components: [ItemName.Bloodlords_Axe, ItemName.Leather_Whip]
    },
    [ItemSetName.Pacifist_Trident]: {
        name: "Pacifist Trident",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 0,
        description: `On Hit: Give the enemy 1 <span style="color:${Color.Riptide}">riptide</span> and gain 1 <span style="color:${Color.Armor}">armor</span> and restore 1 <span style="color:${Color.Health}">health</span>`,
        tags: [ItemTag.Wood],
        components: [ItemName.Pacifist_Staff, ItemName.Silverscale_Trident]
    },
    [ItemSetName.GaleStrike_Rapier]: {
        name: "Galestrike Rapier",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 2,
        speed: 6,
        description: `Battle Start: If you have more <span style="color:${Color.Speed}">speed</span> than the enemy, gain 3 strikes. On Hit: Lose 1 <span style="color:${Color.Speed}">speed</span>`,
        components: [ItemName.Gale_Staff, ItemName.Swiftstrike_Rapier]
    },
    [ItemSetName.Liferoot_Dagger]: {
        name: "Liferoot Dagger",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 2,
        description: `Wounded: Take 2 damage, then gain 3 <span style="color:${Color.Regeneration}">regeneration</span> and 5 <span style="color:${Color.Attack}">attack</span>`,
        tags: [ItemTag.Wood],
        components: [ItemName.Liferoot_Staff, ItemName.Bloodmoon_Dagger]
    },
    [ItemSetName.Perfect_Iceblade]: {
        name: "Perfect Iceblade",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 7,
        description: `You cannot gain <span style="color:${Color.Freeze}">freeze</span>`,
        tags: [ItemTag.Water],
        components: [ItemName.Frozen_Iceblade, ItemName.Melting_Iceblade]
    },
    [ItemSetName.Stonesnake_Sword]: {
        name: "Stonesnake Sword",
        rarity: ItemRarity.Set,
        isWeapon: true,
        attack: 2,
        description: `On Hit: Give the enemy 2 <span style="color:${Color.Poison}">poison</span> and gain 2 <span style="color:${Color.Armor}">armor</span>`,
        tags: [ItemTag.Stone],
        components: [ItemName.Stoneslab_Sword, ItemName.Serpent_Dagger]
    },
    [ItemSetName.Basilisks_Gaze]: {
        name: "Basilisk's Gaze",
        rarity: ItemRarity.Set,
        description: `Battle Start: Your opponent is <span style="color:${Color.Stun}">stunned</span> for 2 turns`,
        components: [ItemName.Basilisk_Fang, ItemName.Basilisk_Scale]
    },
    [ItemSetName.Bloodmoon_Strike]: {
        name: "Bloodmoon Strike",
        description: `Wounded: Restore <span style="color:${Color.Health}">health</span> equal to damage dealt by strikes on your next turn`,
        rarity: ItemRarity.Set,
        components: [ItemName.Bloodmoon_Dagger, ItemName.Swiftstrike_Gauntlet]
    },
    [ItemSetName.Briar_Greaves]: {
        name: "Briar Greaves",
        description: `Whenever you lose <span style="color:${Color.Armor}">armor</span>, gain 1 <span style="color:${Color.Thorns}">thorn</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Assault_Greaves, ItemName.Jagged_Edge] // this thing requires an enchant, that is not supported right now; will be rendered as item for now
    },
    [ItemSetName.Brittlebark_Blessing]: {
        name: "Brittlebark Blessing",
        description: `Brittlebark items have no effect`,
        rarity: ItemRarity.Set,
        components: [ItemName.Brittlebark_Buckler, ItemName.Brittlebark_Armor]
    },
    [ItemSetName.Champions_Greaves]: {
        name: "Champion's Greaves",
        speed: 6,
        rarity: ItemRarity.Set,
        components: [ItemName.Champions_Blade, ItemName.Champions_Armor]
    },
    // [ItemSetName.Crystal_Mirror]: { // this was disabled in update
    //     name: "Crystal Mirror",
    //     description: `Whenever you gain a status effect, give it to the enemy as well`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Sinful_Mirror, ItemName.Marble_Mirror]
    // },
    [ItemSetName.Deadly_Toxin]: {
        name: "Deadly Toxin",
        description: `The first time the enemy gains <span style="color:${Color.Poison}">poison</span>, give the enemy 5 <span style="color:${Color.Acid}">acid</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Nerve_Poison, ItemName.Viper_Extract]
    },
    [ItemSetName.Elderwood_Mask]: {
        name: "Elderwood Mask",
        description: `Battle Start: Double your base <span style="color:${Color.Attack}">attack</span>, <span style="color:${Color.Armor}">armor</span> and <span style="color:${Color.Speed}">speed</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Elderwood_Staff, ItemName.Elderwood_Necklace]
    },
    [ItemSetName.Heros_Return]: {
        name: "Hero's Return",
        attack: 2,
        armor: 2,
        speed: 2,
        rarity: ItemRarity.Set,
        components: [ItemName.Sword_Of_The_Hero, ItemName.Boots_Of_The_Hero, ItemName.Shield_Of_The_Hero]
    },
    [ItemSetName.Highborn]: {
        name: "Highborn",
        description: `Your Ring items trigger 1 additional time`,
        rarity: ItemRarity.Set,
        components: [ItemName.Any_Ring, ItemName.Any_Ring, ItemName.Any_Ring]
    },
    [ItemSetName.Holy_Crucifix]: {
        name: "Holy Crucifix",
        description: `Negates negative base stats`,
        rarity: ItemRarity.Set,
        components: [ItemName.Holy_Shield, ItemName.Holy_Tome]
    },
    [ItemSetName.Iron_Chain]: {
        name: "Iron Chain",
        description: `Exposed & Wounded: Gain 3 <span style="color:${Color.Attack}">attack</span> `,
        rarity: ItemRarity.Set,
        components: [ItemName.Chainmail_Sword, ItemName.Chainmail_Armor]
    },
    [ItemSetName.Ironbark_Shield]: {
        name: "Ironbark Shield",
        description: `Battle Start: If your <span style="color:${Color.Health}">health</span> is full, gain 1 <span style="color:${Color.Armor}">armor</span> at turn start for the rest of battle`,
        rarity: ItemRarity.Set,
        components: [ItemName.Pinecone_Breastplate, ItemName.Stone_Steak]
    },
    [ItemSetName.Ironstone_Arrowhead]: {
        name: "Ironstone Arrowhead",
        description: `On Hit: Gain 1 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Ironstone_Spear, ItemName.Ironstone_Sandals]
    },
    [ItemSetName.Ironstone_Crest]: {
        name: "Ironstone Crest",
        description: `Turn Start: Steal 2 armor from the enemy`,
        rarity: ItemRarity.Set,
        components: [ItemName.Forge_Hammer, ItemName.Forge_Gauntlet]
    },
    [ItemSetName.Ironstone_Fang]: {
        name: "Ironstone Fang",
        description: `First Turn: Gain 3 <span style="color:${Color.Armor}">armor</span> on hit`,
        rarity: ItemRarity.Set,
        components: [ItemName.Venomous_Fang, ItemName.Crimson_Fang]
    },
    // [ItemSetName.Ironstone_Gem]: {
    //     name: "Ironstone Gem",
    //     description: `<span style="color:${Color.Attack}">Attack</span> is always equal to <span style="color:${Color.Speed}">speed</span>`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Ironstone_Greatsword, ItemName.Citrine_Gemstone]
    // },
    // [ItemSetName.Ironstone_Ore]: {
    //     name: "Ironstone Ore",
    //     description: `Battle Start: Gain <span style="color:${Color.Armor}">armor</span> equal to minus <span style="color:${Color.Speed}">speed</span>`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Ironstone_Bracelet, ItemName.Petrified_Statue]
    // },
    [ItemSetName.Lifeblood_Transfusion]: {
        name: "Lifeblood Transfusion",
        description: `Restore 10 <span style="color:${Color.Health}">health</span> after every battle`,
        rarity: ItemRarity.Set,
        components: [ItemName.Iron_Transfusion, ItemName.Lifeblood_Armor]
    },
    [ItemSetName.Marble_Anvil]: {
        name: "Marble Anvil",
        description: `Trigger Exposed at Battle Start instead`,
        rarity: ItemRarity.Set,
        components: [ItemName.Marble_Sword, ItemName.Serpent_Lyre]
    },
    [ItemSetName.Marshlight_Aria]: {
        name: "Marshlight Aria",
        description: `Exposed: Trigger Symphony 3 times`,
        rarity: ItemRarity.Set,
        components: [ItemName.Marshlight_Lantern, ItemName.Riverflow_Violin]
    },
    [ItemSetName.Raw_Hide]: {
        name: "Raw Hide",
        description: `Gain 1 <span style="color:${Color.Attack}">attack</span> every other turn`,
        rarity: ItemRarity.Set,
        components: [ItemName.Leather_Glove, ItemName.Leather_Vest, ItemName.Leather_Boots]
    },
    [ItemSetName.Redwood_Crown]: {
        name: "Redwood Crown",
        description: `Wounded: Restore <span style="color:${Color.Health}">health</span> to full`,
        rarity: ItemRarity.Set,
        components: [ItemName.Redwood_Rod, ItemName.Redwood_Cloak, ItemName.Redwood_Helmet]
    },
    [ItemSetName.Saffron_Talon]: {
        name: "Saffron Talon",
        description: `On Hit: Gain 1 <span style="color:${Color.Speed}">speed</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Featherweight_Blade, ItemName.Saffron_Feather]
    },
    // [ItemSetName.Sanguine_Gemstone]: {
    //     name: "Sanguine Gemstone",
    //     description: `If your <span style="color:${Color.Attack}">attack</span> is exactly 1, restore 1 <span style="color:${Color.Health}">health</span> on hit`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Sanguine_Scepter, ItemName.Granite_Gemstone]
    // },
    [ItemSetName.Seafood_Hotpot]: {
        name: "Seafood Hotpot",
        description: `Battle start: Gain 2 <span style="color:${Color.Armor}">armor</span> for each <span style="color:${Color.Speed}">speed</span> you have`,
        rarity: ItemRarity.Set,
        components: [ItemName.Clearspring_Watermelon, ItemName.Silverscale_Fish, ItemName.Sour_Lemon]
    },
    [ItemSetName.Steelplated_Thorns]: {
        name: "Steelplated Thorns",
        description: `Turn start: If you have less than 10 <span style="color:${Color.Thorns}">thorns</span>, double your <span style="color:${Color.Thorns}">thorns</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Spearshield_Lance, ItemName.Bramble_Buckler]
    },
    [ItemSetName.Twilight_Crest]: {
        name: "Twilight Crest",
        description: `As long as you're below 50% <span style="color:${Color.Health}">health</span>, all healing is doubled`,
        rarity: ItemRarity.Set,
        components: [ItemName.Moonlight_Crest, ItemName.Sunlight_Crest]
    },
    // [ItemSetName.Vampire_Cloak]: {
    //     name: "Vampire Cloak",
    //     description: `Turn Start: If you are <span style="color:${Color.Stun}">stunned</span>, double healing this turn`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Vampiric_Stasis, ItemName.Sanguine_Morphosis]
    // },
    [ItemSetName.Weaver_Medallion]: {
        name: "Weaver Medallion",
        health: 5,
        rarity: ItemRarity.Set,
        components: [ItemName.Weaver_Shield, ItemName.Weaver_Armor]
    },
    // [ItemSetName.Glasses_Of_The_Hero]: {
    //     name: "Glasses of the Hero",
    //     description: `On Hit: Reduce all countdowns by 1`,
    //     rarity: ItemRarity.Set,
    //     components: [ItemName.Heros_Crossguard, ItemName.Tome_Of_The_Hero]
    // },
    [ItemSetName.Liquid_Metal]: {
        name: "Liquid Metal",
        description: `Battle Start: Give the enemy 20 <span style="color:${Color.Armor}">armor</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Rusty_Sword, ItemName.Rusted_Plate]
    },
    [ItemSetName.Bloodstone_Pendant]: {
        name: "Bloodstone Pendant",
        description: `Whenever you restore 5 or more <span style="color:${Color.Health}">health</span> in a single instance, gain 2 <span style="color:${Color.Attack}">attack</span>`,
        rarity: ItemRarity.Set,
        components: [ItemName.Bloodlords_Axe, ItemName.Bloodstone_Ring]
    },
    [ItemSetName.Golden_Jigsaw]: {
        name: "Golden Jigsaw",
        health: 20,
        rarity: ItemRarity.Set,
        components: [ItemName.Small_Kazoo, ItemName.Liferoot_Banjo]
    },
    [ItemSetName.Ironbark_Crest]: {
        name: "Ironbark Crest",
        description: `All wood and stone items have both tags`,
        rarity: ItemRarity.Set,
        components: [ItemName.Ore_Heart, ItemName.Oak_Heart]
    },
    [ItemSetName.Frozen_Spork]: {
        name: "Frozen Spork",
        description: `On Hit: Trigger a random common rarity food item and give the enemy 1 <span style="color:${Color.Freeze}">freeze</span>`,
        isWeapon: true,
        attack: 1,
        rarity: ItemRarity.Set,
        tags: [ItemTag.Water],
        components: [ItemName.Glacial_Spoon, ItemName.Silver_Fork]
    },
    [ItemSetName.Woodcutters_Regret]: {
        name: "Woodcutter's Regret",
        health: -5,
        rarity: ItemRarity.Set,
        components: [ItemName.Woodcutters_Axe, ItemName.Woodcutters_Boots]
    }
}



